import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormMetricsChartType } from 'services/models/form-builder/form-metrics/form-metrics.enum';
import { FormMetricsCategoryClickEvent } from 'services/models/form-builder/form-metrics/form-metrics-drilldown.model';
import { FormMetricsRespondentAnswerItemModel } from 'services/models/form-builder/form-metrics/form-metrics-drilldown.model';
import { FormMetricsGroupModel } from 'services/models/form-builder/form-metrics/form-metrics-group.model';
import { FormMetricsItemModel } from 'services/models/form-builder/form-metrics/form-metrics-item.model';

@Component({
  selector: 'app-form-metrics-group-section',
  templateUrl: './form-metrics-group-section.component.html',
  styleUrls: ['./form-metrics-group-section.component.scss'],
})
export class FormMetricsGroupSectionComponent implements OnChanges {
  @Input() group: FormMetricsGroupModel;
  @Input() highlightedEmployeeId: string | null = null;
  @Input() categoryClickEnabled = false;
  @Input() highlightAnswers: FormMetricsRespondentAnswerItemModel[] = [];
  @Output() openComments = new EventEmitter<FormMetricsItemModel>();
  @Output() categoryClick = new EventEmitter<FormMetricsCategoryClickEvent>();

  visibleItems: FormMetricsItemModel[] = [];
  isCollapsed = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['group'] && this.group) {
      this.visibleItems = (this.group.items || [])
        .filter(item => item.chartType !== FormMetricsChartType.UNSET)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
    }
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  onOpenComments(item: FormMetricsItemModel): void {
    this.openComments.emit(item);
  }

  onCategoryClick(event: FormMetricsCategoryClickEvent): void {
    this.categoryClick.emit(event);
  }

  isFullWidthItem(index: number): boolean {
    const total = this.visibleItems.length;
    return total % 2 === 1 && index === total - 1;
  }

  trackByItemId(_: number, item: FormMetricsItemModel): string {
    return item.formItemId;
  }
}
